import { Combobox } from "components/elements";

export const OrganizationSelector = ({
    value,
    onChange,
    organizations,
    className,
    inputClassName,
    withClear,
    placeholder,
}: {
    value: number | null | undefined;
    onChange: (value: number | null | undefined) => void;
    organizations: { id: number; name: string }[];
    className?: string;
    inputClassName?: string;
    withClear?: boolean;
    placeholder?: string;
}) => {
    const filteredOrganizations = (query: string) => {
        const queriedOrganization =
            query === ""
                ? organizations
                : organizations.filter((organization) =>
                      organization.name.toLowerCase().includes(query.toLowerCase()),
                  );

        return queriedOrganization.map((org) => ({
            value: org.id,
            display: org.name,
        }));
    };

    return (
        <Combobox
            placeholder={placeholder ?? "Select organization"}
            className={className}
            inputClassName={inputClassName}
            value={value}
            withClear={withClear}
            onChange={onChange}
            displayValue={(id) => organizations.find((org) => org.id === id)?.name ?? ""}
            options={filteredOrganizations}
        />
    );
};
